import { ReactNode, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileCTA from "./MobileCTA";
import ScrollToTop from "./ScrollToTop";
import AnnouncementBar from "./AnnouncementBar";

const pageVariants = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" as const } },
  exit: { opacity: 0, y: -8, transition: { duration: 0.2, ease: "easeIn" as const } },
};

const Layout = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const [bannerVisible, setBannerVisible] = useState(true);

  return (
    <div className="min-h-screen flex flex-col">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:text-sm focus:font-medium">
        Skip to content
      </a>
      <AnnouncementBar onDismiss={() => setBannerVisible(false)} />
      <Navbar topOffset={bannerVisible ? 40 : 0} />
      <AnimatePresence mode="wait">
        <motion.main
          id="main-content"
          key={location.pathname}
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          className="flex-1 pb-20 md:pb-0"
        >
          {children}
        </motion.main>
      </AnimatePresence>
      <Footer />
      <MobileCTA />
      <ScrollToTop />
    </div>
  );
};

export default Layout;
